/**
 * Phase 7-lite — global toast behavior overrides.
 *
 * Two goals:
 *   1. Non-error toasts: 8s duration (double Sonner default of 4s) — set in
 *      App.js via Toaster `duration` prop and `closeButton` for tap-to-dismiss.
 *   2. Error toasts: PERSIST UNTIL TAP — duration Infinity. Critical errors
 *      (failed orders, 504s, validation rejects) should never auto-disappear
 *      before the user reads them.
 *
 * This file monkey-patches `toast.error` once at app boot so every existing
 * `import { toast } from 'sonner'` call automatically gets the new behavior
 * without having to migrate every page.
 *
 * Tap the X (closeButton) or swipe to dismiss errors manually.
 */
import { toast } from 'sonner';

let _installed = false;

export function installToastDefaults() {
  if (_installed) return;
  _installed = true;

  const originalError = toast.error.bind(toast);

  toast.error = (message, opts = {}) => {
    return originalError(message, {
      duration: Infinity,
      ...opts, // caller-supplied opts STILL win (so per-call duration overrides still work)
    });
  };

  // Same treatment for warnings — they often signal a state worth reading
  if (typeof toast.warning === 'function') {
    const originalWarning = toast.warning.bind(toast);
    toast.warning = (message, opts = {}) => {
      return originalWarning(message, {
        duration: 12000, // 12s — between info (8s) and error (forever)
        ...opts,
      });
    };
  }
}
